import { render, staticRenderFns } from "./ModalOutOfStockIngredients.vue?vue&type=template&id=78e2b8d8&scoped=true"
import script from "./ModalOutOfStockIngredients.vue?vue&type=script&lang=js"
export * from "./ModalOutOfStockIngredients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2b8d8",
  null
  
)

export default component.exports